var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAouLogoutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25635 13.4688C7.25635 13.8516 6.95557 14.125 6.6001 14.125H4.63135C3.15479 14.125 2.00635 12.9766 2.00635 11.5V4.5C2.00635 3.05078 3.15479 1.875 4.63135 1.875H6.6001C6.95557 1.875 7.25635 2.17578 7.25635 2.53125C7.25635 2.91406 6.95557 3.1875 6.6001 3.1875H4.63135C3.89307 3.1875 3.31885 3.78906 3.31885 4.5V11.5C3.31885 12.2383 3.89307 12.8125 4.63135 12.8125H6.6001C6.95557 12.8125 7.25635 13.1133 7.25635 13.4688ZM15.8149 7.5625L12.3423 3.84375C12.0962 3.57031 11.686 3.57031 11.4126 3.81641C11.1392 4.0625 11.1392 4.47266 11.3853 4.74609L13.8188 7.34375H7.01025C6.65479 7.34375 6.38135 7.64453 6.38135 8C6.38135 8.38281 6.65479 8.65625 7.01025 8.65625H13.7915L11.3306 11.2812C11.0845 11.5547 11.0845 11.9648 11.3579 12.2109C11.522 12.3203 11.686 12.375 11.8228 12.375C11.9868 12.375 12.1509 12.3203 12.2876 12.1836L15.7603 8.46484C16.061 8.21875 16.061 7.80859 15.8149 7.5625Z",
    fill: "#FAA41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAouLogoutIcon);
export default __webpack_public_path__ + "static/media/aou-logout-icon.23366e778ebdd05218f8f91882e58f98.svg";
export { ForwardRef as ReactComponent };